import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#f04444',
    },
    secondary: {
      main: '#d7dce4', 
      light: '#191919',
    },
    success:{
        main:'#619d61',
        light:'#e8f5e9'
    },
    error:{
      main:"#ff0000",
      light:"#ffbf00"
    },
    
  },
  typography: {
    fontFamily: 'Sen, Arial, sans-serif',
    h1: {
      fontSize: '2.5rem',
      fontWeight: 500,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
        },
      },
    },
    MuiStepIcon: {
        styleOverrides: {
          root: {
            // color: '#619d61', // Default color of the step icon (use success color)
            '&.Mui-completed': {
              color: '#619d61', // Color when the step is completed
            },
            '&.Mui-active': {
              color: '#619d61', // Color when the step is active
            },
          },
        },
    },
  },
});

export default theme;